import React, { useState } from 'react'
import "./NavBar.css"
import { Link } from 'react-router-dom';

const NavBar = () => {
      const [isNavExpanded, setIsNavExpanded] = useState(false);
  return (
    <div className='about-kiga-fixed-main-navbar'>
    <div className='about-kiga-logo'>
        <img src='/images/logo2.png' alt='logo'/>
    </div>
    <div className='about-kiga-nav'>
        <ul>
        <li><Link to='/'>Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/classes">Classes</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
            <li><Link to="/register">Booking</Link></li>
            <li><Link to='/contact'>Contact</Link></li>
        </ul>
    </div>
    <div className='about-kiga-portal'>
        <p><Link to='/login'>Parent Portal</Link></p>
    </div>
    <div className="nav-hamburger" onClick={() => setIsNavExpanded(!isNavExpanded)}>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="blue">
              <path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z" clipRule="evenodd" />
            </svg>
          </div>
    
          {/* Mobile fullscreen nav */}
          <div className={isNavExpanded ? 'sub-nav-links-expanded' : 'sub-nav-links'}>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/classes">Classes</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/register">Booking</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/login">Members</Link></li>
            </ul>
            <div className="sub-nav-close-btns" onClick={() => setIsNavExpanded(false)}>
              <p>X</p>
            </div>
            </div>
    </div>
  )
}

export default NavBar